import React from 'react';
import axios from 'axios'
import { Table, Input, Button,Collapse,Popover,Popconfirm,message,Spin,Tabs } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,FundViewOutlined,LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import * as serverconfig from '../serverconn'
import LoanApplicationDetails from './LoanApplicationDetails';
import SpartialData from './SpartialData';

var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

function callback(key) {
  console.log(key);
}
const { TabPane } = Tabs;

var token= ''
var bizuserid= ''

class Licences_Granted extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    licences: [],
    datarequested:true,

    application_files:[],
    selected_application_obj:{}

  };

  componentDidMount(){
    this.comp_reloaded()
    
}

comp_reloaded=()=>{

  if(localStorage.getItem("api_token")){
     token= localStorage.getItem("api_token")
  }else{
     token= ''
  }

  if(localStorage.getItem("bizuserid")){
    bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
 }else{
    bizuserid= ''
 }

  axios.defaults.headers={
    "Content-Type":"application/json",
    Authorization:`Token ${token}`
  }

  axios.get(serverconfig.backendserverurl+`/api/licences/?licence_holder=${bizuserid}`)
  .then(res => {
      this.setState({
          licences:res.data
      })
      this.setState({datarequested:false})
  })



}



getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  this.setState({
    searchText: selectedKeys[0],
    searchedColumn: dataIndex,
  });
};

handleReset = clearFilters => {
  clearFilters();
  this.setState({ searchText: '' });
};



  render() {

    const columns = [
      {
        title: 'Licence Type',
        dataIndex: 'licence_type',
        key: 'id',
        ...this.getColumnSearchProps('licence_type'),
      },
     
      {
        title: 'Grant Date',
        dataIndex: 'grant_date',
        key: 'id',
        ...this.getColumnSearchProps('grant_date'),
      },
      {
        title: 'Application Date',
        dataIndex: 'application_date',
        key: 'id',
        ...this.getColumnSearchProps('application_date'),
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'id',
        ...this.getColumnSearchProps('status'),
      },
      {
        title: 'Licence ID',
        dataIndex: 'code',
        key: 'id',
        ...this.getColumnSearchProps('code'),
      },
      {
        title: 'Expiry date',
        dataIndex: 'expiry_date',
        key: 'id',
        ...this.getColumnSearchProps('expiry_date'),
      },
      {
        title: 'Licence Holder',
        dataIndex: 'licence_holder_name',
        key: 'id',
        ...this.getColumnSearchProps('licence_holder_name'),
      },
      {
        title: 'Renewal Period',
        dataIndex: 'renewal_period',
        key: 'id',
        render: (text,record) =>
          <p>
            {record.renewal_period} Months
          </p>
      },
     
    

    ];
    

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
                <div className="content" />
              </Spin>      
         </div>
      )

    }else{
      return(
        <div>

              <h4>There are {this.state.licences.length} Licences</h4>
                <Table 
                columns={columns} 
                scroll={{ x: 1000 }}
                pagination={{showQuickJumper:true,showSizeChanger:true }}
                dataSource={this.state.licences}
                bordered

                expandable={{
                  expandedRowRender: (record) =>{
                      return (
                        <div>
                       <Tabs
                          defaultActiveKey="1"
                          onChange={() => {}}
                          tabPosition={'top'}
                        >
                          <TabPane tab={"Application details"} key="1">
                            
                            {
                              JSON.stringify(this.state.selected_application_obj)!="{}"?
                              <LoanApplicationDetails 
                              application_record={this.state.selected_application_obj}
                              application_files={this.state.application_files} /> 
                              :
                              null
                            }

                          </TabPane>

                          {this.state.selected_application_obj.licence_type_name==="Spartial"?
                          <TabPane tab={"Shapes"} key="5">
                            <SpartialData 
                             application_id={record.application}
                            />
                          </TabPane>
                          :null}


                        </Tabs>

                        </div>
                      );
                  } ,
                  rowExpandable: (record) => true,
                  onExpand:(condition,record)=>{

                    axios.get(serverconfig.backendserverurl+`/api/application_files/?application=${record.application}`)
                    .then(res => {
                        this.setState({
                          application_files:res.data
                        })
                    })

                    //get selected application object
                    axios.get(`${serverconfig.backendserverurl}/api/applications/${record.application}`)
                    .then(res => {  
                        this.setState({
                            selected_application_obj: res.data
                        })            
                    })



                  },
                }}
                
                />

        </div>
    )

    }

   
  }
}

export default Licences_Granted; 
